import { Injectable } from '@angular/core';
import { SystemConfigService } from '../../system-config/service/system-config.service';
import { PHService } from '../../modules/ph/service/ph.service';
import { MoistureModalService } from '../../modules/moisture/service/moisture-modal.service';
import { SolubilityServiceService } from '../../modules/solubility/service/solubility-service.service';
import { PurityService } from '../../modules/purity/service/purity.service';
import { SystemConfigSettingModel } from '../model/system-config-setting-model';
import { ProductModal } from '../../modules/product/modal/product-modal';
import { Puritymodal } from '../../modules/purity/modal/puritymodal';
import { ResponseCode } from '../../core/constant/response-code';
import { PHModal } from '../../modules/ph/modal/phmodal';
import { MoistureModal } from '../../modules/moisture/modal/moisture-modal';
import { SolubilityModal } from '../../modules/solubility/modal/solubility-modal';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class DefaultMaterialPropertiesService {
  systemConfigModel: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  constructor(
    private systemConfigService: SystemConfigService,
    private phService: PHService,
    private moistureService: MoistureModalService,
    private solubilityService: SolubilityServiceService,
    private purityService: PurityService,
    public toaster: ToastrService
  ) {}

  jsonFyObject(item) {
    return JSON.parse(JSON.stringify(item));
  }

  async setCostParamProperty(item: ProductModal, purityList: Array<Puritymodal>): Promise<Puritymodal> {
    let purity: Puritymodal;
    if (item && item.plainItemConfiguration && item.plainItemConfiguration.purity) {
      purity = this.jsonFyObject(item.plainItemConfiguration.purity);
    } else if (this.systemConfigModel.defaultCostParam > 0) {
      const id = +this.systemConfigModel.defaultCostParam;
      const response = await this.purityService.getById(id).toPromise();
      if (response.responseCode === ResponseCode.OK) {
        const check = purityList.find((ls) => ls.id === response.data.id);
        purity = check ? this.jsonFyObject(response.data) : undefined;
      }
    } else {
      if (purityList && purityList.length === 1) {
        purity = this.jsonFyObject(purityList[0]);
      }
    }
    return purity;
  }

  async setStockParam1Ph(item: ProductModal): Promise<PHModal> {
    let ph: PHModal;
    if (item && item.plainItemConfiguration && item.plainItemConfiguration.ph) {
      ph = this.jsonFyObject(item.plainItemConfiguration.ph);
    } else {
      if (this.systemConfigModel.defaultParam1Id > 0) {
        const id = +this.systemConfigModel.defaultParam1Id;
        const promise = await this.phService.getById(id).toPromise();
        this.validateResponse(promise, () => {
          ph = this.jsonFyObject(promise.data);
        });
      }
    }
    return ph;
  }

  async setStockParam2Moisture(item: ProductModal): Promise<MoistureModal> {
    let moisture: MoistureModal;
    if (item && item.plainItemConfiguration && item.plainItemConfiguration.moisture) {
      moisture = this.jsonFyObject(item.plainItemConfiguration.moisture);
    } else {
      if (this.systemConfigModel.defaultParam2Id > 0) {
        const id = +this.systemConfigModel.defaultParam2Id;
        const promise = await this.moistureService.getById(id).toPromise();
        this.validateResponse(promise, () => {
          moisture = this.jsonFyObject(promise.data);
        });
      }
    }
    return moisture;
  }

  async setStockParam3Solubility(item: ProductModal): Promise<SolubilityModal> {
    let solubility: SolubilityModal;
    if (item && item.plainItemConfiguration && item.plainItemConfiguration.solubility) {
      solubility = this.jsonFyObject(item.plainItemConfiguration.solubility);
    } else {
      if (this.systemConfigModel.defaultParam3Id > 0) {
        const id = +this.systemConfigModel.defaultParam3Id;
        const promise = await this.solubilityService.getById(id).toPromise();
        this.validateResponse(promise, () => {
          solubility = this.jsonFyObject(promise.data);
        });
      }
    }
    return solubility;
  }

  public validateResponse(response, fun: Function) {
    if (response.responseCode !== ResponseCode.OK) {
      this.toaster.error(response.responseMessage, 'Error');
      return;
    }

    fun();
  }
}
